import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import { awaitTimeout } from "@/utils/GlobalJavascriptFunction";
export var api__getRecentlyViewedPostsData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(listOfIdTime, size) {
    var params, cacheKey, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // @FIXME Suhaib add TypeScript types for the response data
          // Construct the params object
          params = {
            posts: listOfIdTime
          };
          cacheKey = JSON.stringify(listOfIdTime === null || listOfIdTime === void 0 ? void 0 : listOfIdTime.map(function (item) {
            return item.post_id;
          }));
          window.__FIXME_BLOCK_PROMISE_2 = window.__FIXME_BLOCK_PROMISE_2 || {};
          window.__FIXME_CACHE_API_2 = window.__FIXME_CACHE_API_2 || {};
          if (!window.__FIXME_BLOCK_PROMISE_2[cacheKey]) {
            _context.n = 1;
            break;
          }
          _context.n = 1;
          return awaitTimeout(2000);
        case 1:
          if (!window.__FIXME_CACHE_API_2[cacheKey]) {
            _context.n = 2;
            break;
          }
          return _context.a(2, window.__FIXME_CACHE_API_2[cacheKey]);
        case 2:
          window.__FIXME_BLOCK_PROMISE_2[cacheKey] = true;

          // Make the GET request with query parameters
          _context.n = 3;
          return fetcher(null, true).post("/search/by-post-ids?size=" + size, params);
        case 3:
          res = _context.v;
          window.__FIXME_CACHE_API_2[cacheKey] = res.data;
          window.__FIXME_BLOCK_PROMISE_2[cacheKey] = undefined;
          // Return the response data
          return _context.a(2, res.data);
      }
    }, _callee);
  }));
  return function api__getRecentlyViewedPostsData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();